import { AxiosError } from 'axios';
import api from '../../../services/cle';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { tratarErroApi } from '../../../rxlib/services/utilitarios';
import { Listagem } from '../../../rxlib/components/layout/listagem';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import { ButtonSplitItem } from '../../../rxlib/components/buttons/button-split';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';
import { AcoesTabela, ConfiguracoesTabela } from '../../../rxlib/components/table';
import { ApiError, LicencaOrganizacaoListagemProps } from '../../../services/tipos';

function LicencaOrganizacaoListagem(props: LicencaOrganizacaoListagemProps) {
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [nomeOrganizacao, setNomeOrganizacao] = useState<string>('');
    const [licencasOrganizacao, setLicencasOrganizacao] = useState<[{}]>([{}]);

    const handleHide = () => setShowWarning(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Organizações e unidades', link: '/organizacao' },
        { texto: 'Licenças da organização', link: '' },
    ];

    const configuracoesTabela: ConfiguracoesTabela = {
        mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
        colunas: [
            { nome: 'Descrição', campo: 'Descricao', tipo: 'string' },
            { nome: 'Chave', campo: 'Chave', tipo: 'string' },
            { nome: 'Expiração', campo: 'Expiracao', tipo: 'date' },
            { nome: 'Status', campo: 'Status', tipo: 'status' },
            { nome: 'Data última consulta', campo: 'DataUltimaConsulta', tipo: 'date' },
        ],
    }

    const buttonSplitItens: ButtonSplitItem[] = [
        { texto: 'Licença personalizada', link: (usuarioTemPermissao(token, 'licenca_organizacao_novo') ? `/organizacao/licenca/${props.match.params.idorganizacao}/novo` : '') },
        { texto: 'Licença base', link: (usuarioTemPermissao(token, 'licenca_organizacao_novo') ? `/organizacao/${props.match.params.idorganizacao}/licencabase/selecao` : '') },
    ];

    const temPermissao = usuarioTemPermissao(token, 'licenca_organizacao_visualizar');
    const linkEdicao = usuarioTemPermissao(token, 'licenca_organizacao_editar') ? `/organizacao/licenca/${props.match.params.idorganizacao}/editar` : '';

    useEffect(() => {
        if (temPermissao) {
            if (props.match.params.idorganizacao) {
                setCarregando(true);
                Promise.all([
                    api.get(`/Organizacao/${props.match.params.idorganizacao}`),
                    api.get(`/OData/LicencaOrganizacao?$filter=idOrganizacao eq ${props.match.params.idorganizacao}`)
                ]).then(response => {
                    setTimeout(() => {
                        setLicencasOrganizacao(response[1].data.value);
                        setNomeOrganizacao(response[0].data.nome);
                        setCarregando(false);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                    setShowWarning(true);
                });
            }
        }
    }, [props.match.params.idorganizacao, temPermissao]);

    function obterAcoesPersonalizadas(): AcoesTabela[] {
        const acoesPersonalizadas: AcoesTabela[] = [];

        if (usuarioTemPermissao(token, 'licenca_organizacao_historico')) {
            acoesPersonalizadas.push({ link: `/organizacao/licenca/${props.match.params.idorganizacao}/historico`, nome: 'Histórico', iconeClassName: 'fas fa-history me-3' });
        }

        return acoesPersonalizadas;
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <Listagem
                    campoId='Id'
                    textoNovo='Nova'
                    tipoBotaoAcao='button'
                    listagemDetalhe={false}
                    carregando={carregando}
                    linkEdicao={linkEdicao}
                    fonteDados={licencasOrganizacao}
                    buttonSplitItens={buttonSplitItens}
                    configuracoesTabela={configuracoesTabela}
                    acoesPersonalizadas={obterAcoesPersonalizadas()}
                    descricao={`Listagem de licenças da organização: ${nomeOrganizacao}`}
                    linkVisualizacao={`/organizacao/licenca/${props.match.params.idorganizacao}/visualizar`} />
                <ModalWarning
                    show={showWarning}
                    onHide={handleHide}
                    message={messageWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
            </RxlibLayout>
        </>
    );
}

export default LicencaOrganizacaoListagem;